import { CardsSectionWrapper } from "./styles"
interface ICardsSectionProps {
	dataList: {
		label: string
		value: number
		icon: JSX.Element
	}
}
export default function CardsSection({ dataList }: ICardsSectionProps) {
	return (
		<CardsSectionWrapper>
			<div>
				<p>{dataList.label}</p>
				<p>{dataList.value}</p>
			</div>
			<div>{dataList.icon}</div>
		</CardsSectionWrapper>
	)
}
